import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { ApiS3Service } from 'src/app/services/api-s3.service';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UsuariosComponent } from "../../sub-filtros/usuarios/usuarios.component";


@Component({
    selector: 'filtro-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [
        trigger('animationRotate', [
            state('close', style({ transform: 'rotate(0)' })),
            state('open', style({ transform: 'rotate(-180deg)' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ]),
        trigger('animationShowHide', [
            state('close', style({ height: '0px', overflow: 'hidden' })),
            state('open', style({ height: '*' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ])
    ],
    imports: [
    CommonModule,
    ModulosDeFormulario,
    MatTooltipModule,
    MatCheckboxModule,
    UsuariosComponent
],
})
export class DashboardComponent implements OnInit {

  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
  @Input('showTodasCotacoes') showTodasCotacoes: boolean = false;
  @Input() listaUsuarios: any = [];
  @Input() corretoraId: string | null = null;


  filtroUsuarioExpandido = true;
  erroBuscarUsuarios: boolean = false;
  userSessao;
  checkboxSelected:any;
  filtroUsuario =  false;
  avatares = {};
  filterUsersSelected = [];
  filtroStatus = 1;
  arrayPage:any = 'dashboard';
  constructor(public apiUsuario: ApiUsuarioService, private apiS3: ApiS3Service, public filtroController: FiltroControllerService) { }

  ngOnInit() {
    this.inicializarFiltros();
  }

  async congigDashbord() {
		this.verificaCheck()
  }

  inicializarFiltros() {
    if (this.filtroController.usersDashboard) {
      this.filterUsersSelected = this.filtroController.usersDashboard ?? [];
    }
  }

  async getAvatarUsuario(usuarioId) {
    try {
      let ret = await this.apiS3.getAvatarUsuario(usuarioId);
      return ret
    } catch (error) {
      return ''
    }
  }

  filterUserSelect(user) {
		for (let _user of this.listaUsuarios.ativos) {
			if (_user.id == user.id) {
				if (user.hasOwnProperty('selected')) {
					if (_user['selected']) {
						this.filterUsersSelected.push(user.id);
						this.filtroController.addUser(user.id, this.arrayPage);
					} else {
						let index = this.filterUsersSelected.findIndex(u => u == user.id);
						this.filterUsersSelected.splice(index, 1);
						this.filtroController.removeUser(user.id, this.arrayPage);
					}
				} else {
					_user['selected'] = true;
					this.filterUsersSelected.push(user.id);
					this.filtroController.addUser(user.id, this.arrayPage);
				}
			}
			_user['selectedDefault'] = false;
		}

    for (let _user of this.listaUsuarios.inativos) {
			if (_user.id == user.id) {
				if (user.hasOwnProperty('selected')) {
					// _user['selected'] = !user['selected'];
					if (_user['selected']) {
						this.filterUsersSelected.push(user.id);
						this.filtroController.addUser(user.id, this.arrayPage);
					} else {
						let index = this.filterUsersSelected.findIndex(u => u == user.id);
						this.filterUsersSelected.splice(index, 1);
						this.filtroController.removeUser(user.id, this.arrayPage);
					}
				} else {
					_user['selected'] = true;
					this.filterUsersSelected.push(user.id);
					this.filtroController.addUser(user.id, this.arrayPage);
				}
			}
			_user['selectedDefault'] = false;
		}
		this.verificaCheck();
	}

  buildString() {
    this.filtroController.addFiltrosExtras(this.arrayPage, {
      userSelected: this.filterUsersSelected,
      status: this.filtroStatus,
    });

    let rawValue = {
      status: this.filtroStatus,
      userSelected: this.filterUsersSelected
    };

    this.filtroController.verificaFiltro();

    let filtros = { values: rawValue };

    this.filtroController.usersDashboard = filtros.values.userSelected;
    
    return filtros;
  }

  clearFilter() {
    this.filterUsersSelected = [];
    this.checkboxSelected = false;
    this.filtroStatus = 1;
    this.filtroController.limparFiltro(this.arrayPage);
    this.limpaFiltro.emit();
    this.filtroController.verificaFiltro();
    this.buildString();
  }

  selectAll() {
		if(this.checkboxSelected) {
			for (let _user of this.listaUsuarios.ativos) {
				_user['selected'] = true;
				this.filtroController.addUser(_user.id, this.arrayPage)
				this.filterUsersSelected.push(_user.id);
			}
			for (let _user of this.listaUsuarios.inativos) {
				_user['selected'] = true;
				this.filtroController.addUser(_user.id, this.arrayPage)
				this.filterUsersSelected.push(_user.id);
			}
			this.verificaCheck()
		} else {
			for (let _user of this.listaUsuarios.ativos) {
				_user['selected'] = false;
				this.filtroController.removeUser(_user.id, this.arrayPage);
			}
			for (let _user of this.listaUsuarios.inativos) {
				_user['selected'] = false;
				this.filtroController.removeUser(_user.id, this.arrayPage);
			}
			this.verificaCheck()
			this.filterUsersSelected = [];
		}
	}

  verificaCheck() {
    const todosAtivosSelecionados = this.listaUsuarios.ativos.every(user => user.selected === true);
    const todosInativosSelecionados = this.listaUsuarios.inativos.every(user => user.selected === true);

    this.checkboxSelected = todosAtivosSelecionados && todosInativosSelecionados;
  }
}